// extracted by mini-css-extract-plugin
export default {"list":"PatientHistory_list__p06sU"};